/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteDiagramEditor } from "./d-theme-white-diagram-editor";

export class DThemeWhiteJaJpDiagramEditor extends DThemeWhiteDiagramEditor {
	override getBaseLayerLabel(): string {
		return "ベースレイヤー";
	}
}
